import { render, staticRenderFns } from "./PopupTitleTemplate.vue?vue&type=template&id=03b930f8"
import script from "./PopupTitleTemplate.vue?vue&type=script&lang=js"
export * from "./PopupTitleTemplate.vue?vue&type=script&lang=js"
import style0 from "./PopupTitleTemplate.vue?vue&type=style&index=0&id=03b930f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports